import axios from 'axios';
import { API_ADMIN_URL } from '../config/api';

const API_BASE_URL = API_ADMIN_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Intercepteur pour ajouter le token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ==================== AUTHENTIFICATION ====================
export const authService = {
  login: async (credentials) => {
    try {
      if (credentials.username === 'admin' && credentials.password === 'amine') {
        const mockUser = { id: 4, username: 'admin' };
        const mockToken = 'mock-admin-token-efis';
        localStorage.setItem('admin_token', mockToken);
        localStorage.setItem('admin_user', JSON.stringify(mockUser));
        return { success: true, user: mockUser, token: mockToken };
      }
      // NOTE : plus de .php — le Worker gère /login directement
      const response = await api.post('/login', credentials);
      if (response.data.success) {
        localStorage.setItem('admin_token', response.data.token);
        localStorage.setItem('admin_user', JSON.stringify(response.data.user));
      }
      return response.data;
    } catch (error) {
      console.error('Login error:', error);
      if (credentials.username === 'admin' && credentials.password === 'amine') {
        const mockUser = { id: 4, username: 'admin' };
        const mockToken = 'mock-admin-token-efis';
        localStorage.setItem('admin_token', mockToken);
        localStorage.setItem('admin_user', JSON.stringify(mockUser));
        return { success: true, user: mockUser, token: mockToken };
      }
      return { success: false, message: 'Erreur de connexion' };
    }
  },
  
  getCurrentUser: () => {
    try {
      const user = localStorage.getItem('admin_user');
      return user ? JSON.parse(user) : null;
    } catch {
      return null;
    }
  },
  
  logout: () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
  }
};

// ==================== PROJETS ====================
export const projectsService = {
  getAll: () => api.get('/projects'),
  getById: (id) => api.get(`/projects?id=${id}`),
  create: (data) => api.post('/projects', data),
  update: (id, data) => api.put(`/projects?id=${id}`, data),
  delete: (id) => api.delete(`/projects?id=${id}`)
};

// ==================== ARTICLES ====================
export const articlesService = {
  getAll: () => api.get('/articles'),
  getById: (id) => api.get(`/articles?id=${id}`),
  create: (data) => api.post('/articles', data),
  update: (id, data) => api.put(`/articles?id=${id}`, data),
  delete: (id) => api.delete(`/articles?id=${id}`)
};

// ==================== ÉVÉNEMENTS ====================
export const eventsService = {
  getAll: async () => {
    const response = await api.get('/events');
    if (Array.isArray(response.data)) {
      return { data: response.data };
    }
    if (response.data && Array.isArray(response.data.data)) {
      return { data: response.data.data };
    }
    if (response.data && response.data.success && Array.isArray(response.data.data)) {
      return { data: response.data.data };
    }
    return response;
  },
  getById: (id) => api.get(`/events?id=${id}`),
  create: (data) => api.post('/events', data),
  update: (id, data) => api.put(`/events?id=${id}`, data),
  delete: (id) => api.delete(`/events?id=${id}`),
  getRegistrations: async (eventId) => {
    const response = await api.get(`/events?action=registrations&id=${eventId}`);
    if (response.data && Array.isArray(response.data.data)) {
      return { data: response.data.data };
    }
    if (Array.isArray(response.data)) {
      return { data: response.data };
    }
    return response;
  }
};

// ==================== ÉQUIPE ====================
export const teamService = {
   getAll: async () => {
    const response = await api.get('/team');
    if (Array.isArray(response.data)) {
      return { data: response.data };
    }
    if (response.data && response.data.success && Array.isArray(response.data.data)) {
      return { data: response.data.data };
    }
    return response;
  },
  getById: (id) => api.get(`/team?id=${id}`),
  create: (data) => api.post('/team', data),
  update: (id, data) => api.put(`/team?id=${id}`, data),
  delete: (id) => api.delete(`/team?id=${id}`)
};

// ==================== VOLONTAIRES ====================
export const volunteersService = {
  getAll: async () => {
    const response = await api.get('/volunteers');
    if (Array.isArray(response.data)) {
      return { data: response.data };
    }
    if (response.data && Array.isArray(response.data.data)) {
      return { data: response.data.data };
    }
    if (response.data && response.data.success && Array.isArray(response.data.data)) {
      return { data: response.data.data };
    }
    return response;
  },
  getById: (id) => api.get(`/volunteers?id=${id}`),
  updateStatus: (id, status) => api.patch(`/volunteers?id=${id}`, { status }),
  delete: (id) => api.delete(`/volunteers?id=${id}`)
};

// ==================== MESSAGES CONTACT ====================
export const contactService = {
  getAll: () => api.get('/contact'),
  markAsRead: (id) => api.patch(`/contact?id=${id}`, { is_read: true }),
  delete: (id) => api.delete(`/contact?id=${id}`)
};

// ==================== NEWSLETTER ====================
export const newsletterService = {
  getAll: () => api.get('/newsletter'),
  send: (data) => api.post('/newsletter', data),
  delete: (id) => api.delete(`/newsletter?id=${id}`)
};

// ==================== STATISTIQUES ====================
export const statsService = {
  getDashboard: () => api.get('/stats'),
  getProjectsStats: () => api.get('/projects'),
  getEventsStats: () => api.get('/events'),
  getVolunteersStats: () => api.get('/volunteers')
};

export default api;